import React from 'react';
import PropTypes from 'prop-types';
import { IgniteIcon } from '@kar-dmp/pattern-library/react';
import { RelativeSize, Icon, PaletteColorV2 } from '@kar-dmp/pattern-library';
import {
  StyledPageEmpty,
  StyledHeader,
  StyledContent,
  StyledIcon
} from './Styles';

const propTypes = {
  header: PropTypes.element,
  content: PropTypes.element
};

const defaultProps = {
  header: undefined,
  content: undefined
};

const TradePageEmpty = ({ header, content }) => {
  return (
    <StyledPageEmpty testId="tradePageEmpty">
      <StyledIcon>
        <IgniteIcon
          icon={Icon.CarSearch}
          color={PaletteColorV2.Neutral3}
          size={RelativeSize.Large}
        />
      </StyledIcon>
      <StyledHeader testId="tradePageEmpty-header">{header}</StyledHeader>
      <StyledContent testId="tradePageEmpty-content">{content}</StyledContent>
    </StyledPageEmpty>
  );
};

TradePageEmpty.propTypes = propTypes;
TradePageEmpty.defaultProps = defaultProps;

export default TradePageEmpty;
